import gql from 'graphql-tag';

const GSS_STUDENT_SETTINGS_FRAGMENT = gql`
  fragment BaseGssStudentSettings on GssStudentSettings {
    locale
    handedness {
      leftHanded
      rtlCrossStroke
    }
    characterOrder {
      letters
      numbers
      wdtNumbers
      wdtLowercase
      wdtCapitals
    }
  }
`;

export default GSS_STUDENT_SETTINGS_FRAGMENT;
